'use strict';

import storybookTemplate from './storybook.component.html';

export default angular
  .module('maestro.directives.components.storybook', [])
  .directive('storybook', function($filter, config) {
    const $t = $filter('translate');
    const DEFAULT_BRAND = 'default';
    const STORY_TYPES = config.getConfigByKey('storyTypes');

    return {
      restrict: 'E',
      template: storybookTemplate,
      scope: {
        deviceModelId: '=',
        brand: '='
      },
      controller: ($scope, utils, I18nService, StoriesService, $state) => {
        const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
        $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);

        angular.extend($scope, {
          viewStory: viewStory,
          getStoryType: getStoryType
        });

        init();

        function init() {
          $scope.$watch('deviceModelId', () => {
            if ($scope.deviceModelId) {
              getStories();
            }
          });
        }

        function getStories() {
          $scope.loading = true;
          return StoriesService.getStories({
            modelId: $scope.deviceModelId,
            brand: $scope.brand || $scope.orgInfo.brand || DEFAULT_BRAND,
            lang: I18nService.getLocale().code,
          })
            .then((data) => {
              $scope.loading = false;
              $scope.stories = (data.stories || []).map(el => {
                let temp = getStoryType(el.storyType);
                el.name = $t(temp.name);
                el.desc = $t(temp.desc);
                el.color = temp.color + '-mark';
                return el;
              });
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function getStoryType(type) {
          return STORY_TYPES.find(el => el.id == type);
        }

        function viewStory(story) {
          if (!story || $scope.loading) {
            return;
          }
          let availableStories = $scope.stories.map(el => {
            return {id: el.id, name: el.name};
          });
          $state.go('main.stories.view', { storyId: story.id, story: story, deviceModelId: $scope.deviceModelId, availableStories: availableStories });
        }
      }
    };
  })

  .name;
